import '../../App.css';
import Header from '../../components/header/Header';
import FormRegister from '../../components/form/FormRegister';
import About from '../../components/about/About';
import Footer from '../../components/footer/Footer';

function App() {
  return (
    <>
      <Header />
      <About />
      <FormRegister />
      <Footer />
    </>
  );
}

export default App;